import React from 'react'
import htmlToReact from 'html-to-react'

const output_social_icon = social => {
  const social_icons = {
    facebook: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.5 2 2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12c0-5.5-4.5-10-10-10z"></path></svg>),
    instagram: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M12,4.622c2.403,0,2.688,0.009,3.637,0.052c0.877,0.04,1.354,0.187,1.671,0.31c0.42,0.163,0.72,0.358,1.035,0.673 c0.315,0.315,0.51,0.615,0.673,1.035c0.123,0.317,0.27,0.794,0.31,1.671c0.043,0.949,0.052,1.234,0.052,3.637 s-0.009,2.688-0.052,3.637c-0.04,0.877-0.187,1.354-0.31,1.671c-0.163,0.42-0.358,0.72-0.673,1.035 c-0.315,0.315-0.615,0.51-1.035,0.673c-0.317,0.123-0.794,0.27-1.671,0.31c-0.949,0.043-1.233,0.052-3.637,0.052 s-2.688-0.009-3.637-0.052c-0.877-0.04-1.354-0.187-1.671-0.31c-0.42-0.163-0.72-0.358-1.035-0.673 c-0.315-0.315-0.51-0.615-0.673-1.035c-0.123-0.317-0.27-0.794-0.31-1.671C4.631,14.688,4.622,14.403,4.622,12 s0.009-2.688,0.052-3.637c0.04-0.877,0.187-1.354,0.31-1.671c0.163-0.42,0.358-0.72,0.673-1.035 c0.315-0.315,0.615-0.51,1.035-0.673c0.317-0.123,0.794-0.27,1.671-0.31C9.312,4.631,9.597,4.622,12,4.622 M12,3 C9.556,3,9.249,3.01,8.289,3.054C7.331,3.098,6.677,3.25,6.105,3.472C5.513,3.702,5.011,4.01,4.511,4.511 c-0.5,0.5-0.808,1.002-1.038,1.594C3.25,6.677,3.098,7.331,3.054,8.289C3.01,9.249,3,9.556,3,12c0,2.444,0.01,2.751,0.054,3.711 c0.044,0.958,0.196,1.612,0.418,2.185c0.23,0.592,0.538,1.094,1.038,1.594c0.5,0.5,1.002,0.808,1.594,1.038 c0.572,0.222,1.227,0.375,2.185,0.418C9.249,20.99,9.556,21,12,21s2.751-0.01,3.711-0.054c0.958-0.044,1.612-0.196,2.185-0.418 c0.592-0.23,1.094-0.538,1.594-1.038c0.5-0.5,0.808-1.002,1.038-1.594c0.222-0.572,0.375-1.227,0.418-2.185 C20.99,14.751,21,14.444,21,12s-0.01-2.751-0.054-3.711c-0.044-0.958-0.196-1.612-0.418-2.185c-0.23-0.592-0.538-1.094-1.038-1.594 c-0.5-0.5-1.002-0.808-1.594-1.038c-0.572-0.222-1.227-0.375-2.185-0.418C14.751,3.01,14.444,3,12,3L12,3z M12,7.378 c-2.552,0-4.622,2.069-4.622,4.622S9.448,16.622,12,16.622s4.622-2.069,4.622-4.622S14.552,7.378,12,7.378z M12,15 c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S13.657,15,12,15z M16.804,6.116c-0.596,0-1.08,0.484-1.08,1.08 s0.484,1.08,1.08,1.08c0.596,0,1.08-0.484,1.08-1.08S17.401,6.116,16.804,6.116z"></path></svg>),
    twitter: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M22.23,5.924c-0.736,0.326-1.527,0.547-2.357,0.646c0.847-0.508,1.498-1.312,1.804-2.27 c-0.793,0.47-1.671,0.812-2.606,0.996C18.324,4.498,17.257,4,16.077,4c-2.266,0-4.103,1.837-4.103,4.103 c0,0.322,0.036,0.635,0.106,0.935C8.67,8.867,5.647,7.234,3.623,4.751C3.27,5.357,3.067,6.062,3.067,6.814 c0,1.424,0.724,2.679,1.825,3.415c-0.673-0.021-1.305-0.206-1.859-0.513c0,0.017,0,0.034,0,0.052c0,1.988,1.414,3.647,3.292,4.023 c-0.344,0.094-0.707,0.144-1.081,0.144c-0.264,0-0.521-0.026-0.772-0.074c0.522,1.63,2.038,2.816,3.833,2.85 c-1.404,1.1-3.174,1.756-5.096,1.756c-0.331,0-0.658-0.019-0.979-0.057c1.816,1.164,3.973,1.843,6.29,1.843 c7.547,0,11.675-6.252,11.675-11.675c0-0.178-0.004-0.355-0.012-0.531C20.985,7.47,21.68,6.747,22.23,5.924z"></path></svg>),
    linkedin: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M19.7,3H4.3C3.582,3,3,3.582,3,4.3v15.4C3,20.418,3.582,21,4.3,21h15.4c0.718,0,1.3-0.582,1.3-1.3V4.3 C21,3.582,20.418,3,19.7,3z M8.339,18.338H5.667v-8.59h2.672V18.338z M7.004,8.574c-0.857,0-1.549-0.694-1.549-1.548 c0-0.855,0.691-1.548,1.549-1.548c0.854,0,1.547,0.694,1.547,1.548C8.551,7.881,7.858,8.574,7.004,8.574z M18.339,18.338h-2.669 v-4.177c0-0.996-0.017-2.278-1.387-2.278c-1.389,0-1.601,1.086-1.601,2.206v4.249h-2.667v-8.59h2.559v1.174h0.037 c0.356-0.675,1.227-1.387,2.526-1.387c2.703,0,3.203,1.779,3.203,4.092V18.338z"></path></svg>),
    youtube: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M21.8,8.001c0,0-0.195-1.378-0.795-1.985c-0.76-0.797-1.613-0.801-2.004-0.847c-2.799-0.202-6.997-0.202-6.997-0.202 h-0.009c0,0-4.198,0-6.997,0.202C4.608,5.216,3.756,5.22,2.995,6.016C2.395,6.623,2.2,8.001,2.2,8.001S2,9.62,2,11.238v1.517 c0,1.618,0.2,3.237,0.2,3.237s0.195,1.378,0.795,1.985c0.761,0.797,1.76,0.771,2.205,0.855c1.6,0.153,6.8,0.201,6.8,0.201 s4.203-0.006,7.001-0.209c0.391-0.047,1.243-0.051,2.004-0.847c0.6-0.607,0.795-1.985,0.795-1.985s0.2-1.618,0.2-3.237v-1.517 C22,9.62,21.8,8.001,21.8,8.001z M9.935,14.594l-0.001-5.62l5.404,2.82L9.935,14.594z"></path></svg>),
    feed: (<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M2,8.667V12c5.515,0,10,4.485,10,10h3.333C15.333,14.637,9.363,8.667,2,8.667z M2,2v3.333 c9.19,0,16.667,7.477,16.667,16.667H22C22,10.955,13.045,2,2,2z M4.5,17C3.118,17,2,18.12,2,19.5S3.118,22,4.5,22S7,20.88,7,19.5 S5.882,17,4.5,17z"></path></svg>),
  }

  if ( social_icons.hasOwnProperty(social) ) {
    return (
      <>
      { social_icons[social] }
      <span className="sr-only">{social}</span>
      </>
    )
  } else {
    return social
  }
}

const Footer = (props) => {
  const {
    campus_info,
    social_links,
    arrow_links,
    footer_nav_title,
    footer_nav_links,
    legal_links,
  } = props.data.footer

  const network_home_url = props.data.network_home_url
  const network_home_theme_url = props.data.network_home_theme_url
  const htmlToReactParser = new htmlToReact.Parser()

  const renderAddress = (campus) => {
    if ( campus.address) return (
      <address className="mt-10 not-italic text-16 tracking-10">
        {htmlToReactParser.parse(campus.address)}
      </address>
    )
    return ''
  }
  const renderPhone = (campus) => {
    if ( campus.phone) return (
      <a className="underline lg:no-underline text-16" href={`tel:${campus.phone}`}>{campus.phone}</a>
    )
    return ''
  }

  return (
<footer id="footer" className="relative w-full p-0 bg-gray-dark text-white font-sans overflow-hidden">
  <img className="absolute top-128 xl:top-48 left-128 md:left-1/2 lg:left-auto lg:right-24 w-560 pointer-events-none" 
    src={`${network_home_theme_url}public/images/seal.png`} alt="" aria-hidden="true" />
  <div className="container relative z-1 pt-48 md:py-80">
    <div className="px-12 md:flex md:flex-wrap">
      <div className="md:w-6/12 lg:w-4/12 px-12 md:order-2">
        <a href={network_home_url} className="d-block md:hidden w-288">
          <img className="d-block" src={`${network_home_theme_url}public/images/logo.png`} alt="Western University of Health Sciences Logo"/>
        </a>
        <div className="xl:flex mt-40 lg:mt-0 text-20 xl:text-16 leading-130">
            {campus_info.map((campus, i) => {
              return (
                <div className={i === 0 ? 'xl:mr-64' : 'mt-24 xl:mt-0'} key={i}>
                  <h2 className="pb-0 font-serif font-bold tracking-10 text-yellow">{campus.title}</h2>
                  <div className="mt-8">
                  {campus.is_info_html && htmlToReactParser.parse(campus.info_html)}
                  {!campus.is_info_html && renderAddress(campus)}
                  {!campus.is_info_html && renderPhone(campus)}
                  {campus.security_title && (
                    <div className="mt-24">
                      <h3 className="font-serif font-bold tracking-10 text-yellow normal-case">{campus.security_title}</h3>
                      <div className="mt-8">
                        {campus.is_html && htmlToReactParser.parse(campus.security_content)}
                        {!campus.is_html && (
                          <a className="underline lg:no-underline text-16" href={`tel:${campus.security_phone}`}>{campus.security_phone}</a>
                        )}
                      </div>
                    </div>
                  )}
                  </div>
                </div>
              )
            })}
        </div>
      </div>
      <div className="w-full lg:w-4/12 px-12 md:order-1">
        <a href={network_home_url} className="hidden md:block w-256">
          <img className="d-block" src={`${network_home_theme_url}public/images/wordmark.png`} alt="WesternU Logo"/>
        </a>
        <div className="md:flex md:flex-col-reverse">
          {social_links.length > 0 && (
            <ul className="w-full flex flex-wrap space-x-8 mt-40 md:mt-24">
              {social_links.map((item, i) => {
                return (
                  <li className="d-block w-32 mt-0" key={i}>
                    <a className="d-block w-32 h-32 hover:text-yellow transition-colors duration-100 ease-linear fill-current"
                      href={item.url} target="_blank" rel="noopener">
                      {output_social_icon(item.platform)}
                    </a>
                  </li>
                )
              })}
          </ul>
          )}
          <ul className="w-full mt-8 text-18 md:text-16 mt-24 md:mt-32">
            {arrow_links.map((item, i) => {
              if (item.link) {
                const { url, target, title } = item.link
                return (
                  <li className="d-block mt-6 leading-120" key={i}>
                    <a className={`cta-arrow cta-arrow--footer`} 
                      href={url}
                      {...(target && {target: target, rel: 'noopener'})}
                    >
                      {title}<svg className="cta-arrow__icon d-block w-16 ml-12" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg"><polygon fill="currentColor" points="11.3168217 0 9.27266614 2.39591605 14.0042587 6.6137266 8.92524936 6.42314237 0 6.42314237 0 9.57685763 8.92524936 9.57685763 14.0042587 9.3862734 9.19197579 13.6063528 11.3168217 16 20 8"></polygon></svg>
                    </a>
                  </li>
                )
              }
            })}
          </ul>
        </div>
      </div>
      <div className="md:w-6/12 lg:w-4/12 px-12 md:order-3 tracking-10">
        <div className="border-t-1 md:border-t-0 border-gray-medium mt-40 lg:mt-0 pt-40 md:pt-0">
          <h2 className="pb-0 font-serif font-bold text-20 xl:text-16 leading-130 text-yellow">
            { footer_nav_title }
          </h2>
          <ul className="w-full mt-8 text-18 md:text-16">
            {footer_nav_links.map((item, i) => {
              if (item.link) {
                const { url, target, title } = item.link
                return (
                  <li className="d-block mt-8 leading-120" key={i}>
                    <a className="hover:underline" 
                      href={url}
                     {...(target && {target: target, rel: 'noopener'})}
                    >{ title }</a>
                  </li>
                )
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div className="relative z-1 md:bg-gray-darker pb-40 md:py-16">
    <div className="container">
      <div className="px-12">
        <div className="px-12">
          <ul className="w-full md:flex md:flex-wrap text-14 border-t-1 md:border-t-0 border-gray-medium mt-40 md:mt-0 pt-40 md:pt-0">
            {legal_links.map((item, i) => {
              if (item.link) {
                const { url, target, title } = item.link
                return (
                  <li className="inline-block md:block my-6 mr-24 leading-100" key={i}>
                    <a className="hover:underline" 
                      href={url}
                     {...(target && {target: target, rel: 'noopener'})}
                    >{ title }</a>
                  </li>
                )
              }
            })}
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
  )
}
export default Footer
